import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
	selector: "bp-error-box",
	templateUrl: "./bp-error-box.component.html",
	styleUrls: ["./bp-error-box.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class BpErrorBoxComponent {}
